export default __webpack_public_path__ + "fonts/aiFilterCardHeaderIcon.svg";